import { getCountryName } from "./utils";

export const propertyAddressFix = (address: string): string => {
  const formattedAddress = address?.replace(", , ", ", ");
  const addressBrokenUp = formattedAddress?.split(", ") ?? [];
  const country = getCountryName(addressBrokenUp?.[addressBrokenUp.length - 1]);
  if (addressBrokenUp?.[1] && country) {
    return `${addressBrokenUp.slice(0, addressBrokenUp.length - 1).join(", ")}, ${country}`;
  }
  return formattedAddress;
};

const isSearchSessionPath = (path: string): boolean => {
  return /^\/hotel\/search\/[^/]+$/.test(path);
};

export const encodeText = (text: string): string => {
  if (text === "/hotel/search") {
    return "hs";
  } else if (isSearchSessionPath(text)) {
    return "hsr";
  } else if (text === "/deals") {
    return "d";
  }
  return text;
};

export const decodeText = (encodedText: string): string => {
  if (encodedText === "hs") {
    return "/hotel/search";
  } else if (encodedText === "hsr") {
    return "/hotel/search/results";
  } else if (encodedText === "d") {
    return "/deals";
  }
  return encodedText;
};

// Contexts where the user already holds a reservation for the hotel they're
// viewing. The details page reuses the search-result details layout in these
// flows, so availability-empty states that make sense during shopping should
// be suppressed here.
export const isReservationSource = (source: string | undefined): boolean => {
  if (!source) return false;
  const decoded = decodeText(source);
  return (
    decoded === "/my-trips" ||
    decoded.startsWith("/my-trips/") ||
    decoded.startsWith("/hotel/book/status/")
  );
};
